import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ActiveResolutionList from "./ActiveResolutionList";

const ActiveResolution = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Active Resolution" />
          <ActiveResolutionList />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ActiveResolution;
